import type { ProviderKind } from "@cmmd-forge/contracts";
import { createElement } from "react";

import { ClaudeAI, CursorIcon, OpenAI, OpenCodeIcon, type Icon } from "./Icons";

const CommandProviderIcon: Icon = (props) =>
  createElement(
    "svg",
    {
      ...props,
      viewBox: props.viewBox ?? "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": props["aria-hidden"] ?? true,
    },
    createElement("path", { d: "M9 6a3 3 0 1 0-3 3h3V6Z" }),
    createElement("path", { d: "M15 6a3 3 0 1 1 3 3h-3V6Z" }),
    createElement("path", { d: "M9 18a3 3 0 1 1-3-3h3v3Z" }),
    createElement("path", { d: "M15 18a3 3 0 1 0 3-3h-3v3Z" }),
    createElement("path", { d: "M9 9h6v6H9z" }),
  );

// Shared with Settings and first-run setup so provider identity stays visually consistent.
export const PROVIDER_SETTINGS_ICON_BY_PROVIDER: Partial<Record<ProviderKind, Icon>> = {
  codex: OpenAI,
  claudeAgent: ClaudeAI,
  apex: CommandProviderIcon,
  cmmd: CommandProviderIcon,
  ollama: OpenAI,
  cursor: CursorIcon,
  opencode: OpenCodeIcon,
};
